import BaseRepository from './base-repository';

import { Media, Media$ExternalPage } from '@/types/Media';

export type PlaylistItem = {
  allowExternalPage: Media$ExternalPage;
} & Media;

if (process.env.VUE_APP_MOCK_API === 'yes') {
  (function _bootstrap() {
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    const adapert = require('../mocks/index').default;
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    const fnc = require('../mocks/playlist-items').default;
    fnc(adapert);
  })();
}

export default class PlaylistMediaRepository extends BaseRepository<PlaylistItem> {
  constructor(id: string) {
    super(`/media/${id}/items`);
  }
}
